var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBackWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0413 0.000484467C6.28675 0.000484467 0.000484467 6.28675 0.000484467 14.0413C0.000484467 21.7958 6.28675 28.082 14.0413 28.082C21.7958 28.082 28.082 21.7958 28.082 14.0413C28.082 6.28675 21.7958 0.000484467 14.0413 0.000484467Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2062 7.31662L13.8867 8.00357L7.85182 14.0385L13.8867 20.0734L13.2062 20.7539L6.49076 14.0385L13.2062 7.31662Z",
    fill: "#FFF057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17259 14.5195H22.4268V13.5565H7.17259V14.5195Z",
    fill: "#FFF057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackWebsite);
export default __webpack_public_path__ + "static/media/go-back-website.00a73cedb0a66934fc73178676e8f47b.svg";
export { ForwardRef as ReactComponent };